module.exports = __webpack_public_path__ + "media/soft.f0ced2f3.mp3";